import print from './init';

const printJS = print.init;

if (typeof window !== 'undefined') {
  window.printJS = printJS;
}

export default printJS;
